import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-new-about',
  templateUrl: './edit-new-about.component.html',
  styleUrls: ['./edit-new-about.component.scss']
})
export class EditNewAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
